// Seasonal decoration window (visitor's local time; `until` is exclusive). Used by Halloween_fx and the
// page-change Spinner, so both switch on and off together with no redeploy.
export const HALLOWEEN = { from: new Date(2026, 10, 1), until: new Date(2026, 10, 16) }; // 1-15 Nov 2026

export function isHalloween(now = new Date()) {
  return now >= HALLOWEEN.from && now < HALLOWEEN.until;
}
